import { useCallback } from 'react';
import { useImmerAtom } from 'jotai-immer';
import { validateNPI } from '../../../../core/components/validation/validators';
import { ngDelegate } from '../../../../core/services/ng.delegate';
import { cloneDeep } from 'lodash';

// provider imports
import { PROVIDER_LIST_FORM_KEY } from '../../provider_const';
import tableViewRepo from '../../../../core/repo/viewStateRepo';
import { AdminProviderSearchModel } from '../provider_list_types';
import { providerSearchFormAtom } from '../provider_list_atoms';
import { useProviderListStore } from '../pagehooks/useProviderListStore';

export type ProviderSearchHook = {
    state: AdminProviderSearchModel;
    setProperty: (key: string, val: any) => void;
    toggleChecked: (key: string, val: boolean) => void;
    handleSearch: () => void;
};

export const useProviderSearch = (): ProviderSearchHook => {
    const [state, setState] = useImmerAtom(providerSearchFormAtom);
    const pageStore = useProviderListStore();

    const setProperty = useCallback(
        (key: string, val: any): void => {
            setState(draft => {
                draft[key].val = val;
            });
        },
        [setState],
    );

    const validate = useCallback((): boolean => {
        let result = true;
        setState(draft => {
            result = result && validateNPI(draft.NPI);
            return draft;
        });
        return result;
    }, [setState]);

    const toggleChecked = useCallback(
        (key: string, val: boolean): void => {
            setState(draft => {
                draft[key].checked = val;
            });
        },
        [setState],
    );

    const submit = (): void => {
        if (!validate()) {
            ngDelegate.ok('Cannot Search', 'Check properties');
            return;
        }

        // query manages its own persistence, not the table
        const stateClone = cloneDeep(state);
        stateClone.CE.options = []; // do not persist options, too expensive, this will REALLY hold true for bigger option lists in the query
        tableViewRepo.setForm(PROVIDER_LIST_FORM_KEY, stateClone);

        // the job of search is to send off the query, it is a child of page state and doesn't affect it
        pageStore.getList(state);
    };

    return {
        state,
        setProperty,
        toggleChecked,
        handleSearch: submit,
    };
};

export default useProviderSearch;
